<template>
  <div class="mypage-navigator-container">
    <div class="mypage-navigator-button-logout">
      <span @click="showLogoutModal()">로그아웃 〉</span>
      <MyPageLogoutModalVue :logoutModal="logoutModal" @closeLogout="closeLogoutModal()"></MyPageLogoutModalVue>
    </div>
  </div>
</template>

<script>
import MyPageLogoutModalVue from './MyPageLogoutModal.vue'

export default {
  name: 'MyPageNavigator',
  components: {
    MyPageLogoutModalVue
  },

  data() {
    return {
      logoutModal: false
    }
  },

  methods: {
    showLogoutModal() {
      this.logoutModal = true
    },

    closeLogoutModal() {
      this.logoutModal = false
    }
  }
}
</script>

<style>
.mypage-navigator-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: var(--font-sans);
}
.mypage-navigator-button-logout {
  width: 100%;
  margin-top: 24px;
  padding: 8px 4px;
  box-sizing: border-box;
  color: var(--ink-400);
  text-align: right;
  font-size: 16px;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}
.mypage-navigator-button-logout:hover {
  color: var(--green-600);
}
</style>